const settingsCv3ukdemo = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': true,
  'autoupdate.s3-bucket-name': 'aibms',
  'autoupdate.s3-endpoint': 'kineticsmart.com',
  'autoupdate.s3-prefix': 'files/kinetic_go/demo/vega3000',
  'device.name': 'Demo / Dev',
  'device.show_name': true,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': '',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': true,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.industry': 'retail',
  'merchant.logon': true,
  'merchant.manual_limit': 20000,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46195',
  'merchant.process_url': 'testssl2.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'team@kineticsmart.com',
  'merchant.support_phone': '',
  'merchant.swipe_limit': 35000,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'logo_320x60',
  'timezone.region': 'GB-London'
}

const settingsCv3PINPADukdemo = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': true,
  'autoupdate.s3-bucket-name': 'aibms',
  'autoupdate.s3-endpoint': 'kineticsmart.com',
  'autoupdate.s3-prefix': 'files/kinetic_go/demo/vega3000',
  'device.name': 'Demo / Dev',
  'device.show_name': true,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': '',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': true,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.force_return_to_idle': true,
  'merchant.industry': 'retail',
  'merchant.logon': true,
  'merchant.manual_limit': 20000,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46195',
  'merchant.process_url': 'testssl2.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'team@kineticsmart.com',
  'merchant.support_phone': '',
  'merchant.swipe_limit': 35000,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.printer': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'logo_320x60',
  'timezone.region': 'GB-London'
}

const settingsCmp200ukdemo = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': true,
  'autoupdate.s3-bucket-name': 'aibms',
  'autoupdate.s3-endpoint': 'kineticsmart.com',
  'autoupdate.s3-prefix': 'files/kinetic_go/demo/mp200',
  'device.name': 'Demo / Dev',
  'device.show_name': true,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': '',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': true,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.industry': 'retail',
  'merchant.logon': true,
  'merchant.manual_limit': 20000,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46195',
  'merchant.process_url': 'testssl2.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'team@kineticsmart.com',
  'merchant.support_phone': '',
  'merchant.swipe_limit': 35000,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'logo_320x60',
  'timezone.region': 'GB-London'
}

export const cv3ukdemo = settingsCv3ukdemo
export const cmp200ukdemo = settingsCmp200ukdemo
export const cv3ppukdemo = settingsCv3PINPADukdemo
